export interface AccountItemProps {
    title: string;
    isDarkMode: boolean; // 是否是暗黑模式
    statusIcon?: React.ReactNode; // 状态icon
    isLink: boolean; // 是否是一个可以点击的link(或者按钮)
    disabledLink?: boolean; // 是否要禁用连接
    btnText?: string; // 按钮的文案
    eventParams?: {
        eventModel?: string;
        eventType: string;
        eventName: string;
    };
    onClick?: () => void;
}

export enum EditTypeEnum {
    CERTIFICATE = 'certificate', // 修改证件/文件
    ADDRESS = 'address', // 修改居住地址
    WORK_PROFILE = 'work_profile', // 修改工作信息
    ASSETS = 'assets', // 修改资产信息
    INVEST_TARGET = 'invest_target', // 修改投资目的
    SIGNATURE = 'signature', // 已开户用户补全签名
    QUESTIONNAIRE = 'qual_questionnaire', // 修改问卷
    REGULATORY_INFO = 'regulatory_info', // 修改规管信息
    BENEFICIARY = 'beneficiary' // 修改受益人信息
}

export interface UpdateInfoItem {
    title: string;
    path: string;
    type: EditTypeEnum;
    eventName: string;
}

// 进度状态枚举
export enum ProcessStatusEnum {
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    SUCCESS = 'SUCCESS',
    INVALID = 'INVALID'
}
